<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-mixed">Contents</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/newslettersignup"><span class="toc-item-title-text cspan">Newsletter sign-up</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter001"><span class="toc-item-title-text cspan">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter002"><span class="toc-item-title-text cspan">Chapter 2</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter003"><span class="toc-item-title-text cspan">Chapter 3</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter004"><span class="toc-item-title-text cspan">Chapter 4</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter005"><span class="toc-item-title-text cspan">Chapter 5</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter006"><span class="toc-item-title-text cspan">Chapter 6</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter007"><span class="toc-item-title-text cspan">Chapter 7</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter008"><span class="toc-item-title-text cspan">Chapter 8</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter009"><span class="toc-item-title-text cspan">Chapter 9</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter010"><span class="toc-item-title-text cspan">Chapter 10</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter011"><span class="toc-item-title-text cspan">Chapter 11</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter012"><span class="toc-item-title-text cspan">Chapter 12</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter013"><span class="toc-item-title-text cspan">Chapter 13</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter014"><span class="toc-item-title-text cspan">Chapter 14</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter015"><span class="toc-item-title-text cspan">Chapter 15</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter016"><span class="toc-item-title-text cspan">Chapter 16</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter017"><span class="toc-item-title-text cspan">Chapter 17</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter018"><span class="toc-item-title-text cspan">Chapter 18</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter019"><span class="toc-item-title-text cspan">Chapter 19</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter020"><span class="toc-item-title-text cspan">Chapter 20</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter021"><span class="toc-item-title-text cspan">Chapter 21</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter022"><span class="toc-item-title-text cspan">Chapter 22</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter023"><span class="toc-item-title-text cspan">Chapter 23</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter024"><span class="toc-item-title-text cspan">Chapter 24</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter025"><span class="toc-item-title-text cspan">Chapter 25</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter026"><span class="toc-item-title-text cspan">Chapter 26</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter027"><span class="toc-item-title-text cspan">Chapter 27</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter028"><span class="toc-item-title-text cspan">Chapter 28</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter029"><span class="toc-item-title-text cspan">Chapter 29</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter030"><span class="toc-item-title-text cspan">Chapter 30</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter031"><span class="toc-item-title-text cspan">Chapter 31</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter032"><span class="toc-item-title-text cspan">Chapter 32</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter033"><span class="toc-item-title-text cspan">Chapter 33</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter034"><span class="toc-item-title-text cspan">Chapter 34</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter035"><span class="toc-item-title-text cspan">Chapter 35</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter036"><span class="toc-item-title-text cspan">Chapter 36</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter037"><span class="toc-item-title-text cspan">Chapter 37</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter038"><span class="toc-item-title-text cspan">Chapter 38</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter039"><span class="toc-item-title-text cspan">Chapter 39</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter040"><span class="toc-item-title-text cspan">Chapter 40</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter041"><span class="toc-item-title-text cspan">Chapter 41</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter042"><span class="toc-item-title-text cspan">Chapter 42</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter043"><span class="toc-item-title-text cspan">Chapter 43</span></a></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/alsobyjofenton"><span class="toc-item-title-text cspan">Also by Jo Fenton</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/youwillalsoenjoy"><span class="toc-item-title-text cspan">You will also enjoy:</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/newslettersignup2"><span class="toc-item-title-text cspan">Newsletter sign-up</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/acknowledgements" title="Link target outside of Sample"><span class="toc-item-title-text cspan">Acknowledgements</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/abouttheauthor"><span class="toc-item-title-text cspan">About the Author</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/anotefromthepublisher"><span class="toc-item-title-text cspan">A note from the publisher</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?63813e62